import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { t } from '../../lib/i18n';

const triggerClass = 'bg-black/20 border-white/10 text-white';
const contentClass = 'bg-[var(--lux-panel)] border-white/10';

/**
 * Labelled select for onboarding. `options` may be an array of translation keys
 * (string) or objects {value,label}. Translation keys are resolved with i18n.
 */
export const ProfileSelect = ({ label, value, onChange, options, language, placeholder, testId }) => (
  <div className="space-y-2">
    <Label className="text-white/60 text-xs">{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={triggerClass}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={contentClass}>
        {options.map((opt) => {
          const optionValue = typeof opt === 'string' ? opt : opt.value;
          const optionLabel = typeof opt === 'string' ? t(opt, language) : opt.label;
          return (
            <SelectItem key={optionValue} value={optionValue} className="text-white hover:bg-white/5">
              {optionLabel}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  </div>
);
